import { useMutation } from '@tanstack/react-query';
import { ssoHandoff } from '../services/subscriptions.api';

export function useSsoHandoff() {
  return useMutation({
    mutationFn: (subscriptionId: string) => ssoHandoff(subscriptionId),
    onSuccess: ({ url }) => {
      window.location.href = url;
    },
  });
}
